<div class="platform-content-container">
    <h1 class="solcitare-title">Editare conținut platformă</h1>
    <form class="platform-content-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="platform-content-nume">
            <mat-form-field appearance="fill">
                <mat-label>Titlu</mat-label>
                <input type="text" matInput formControlName="name">
            </mat-form-field>
            <mat-error *ngIf="!form.controls['name'].valid && form.controls['name'].touched">
                Câmp obligatoriu
            </mat-error>
        </div>
        <div class="platform-content-observations">
            <mat-form-field appearance="fill">
                <mat-label>Observații</mat-label>
                <input type="text" matInput formControlName="observations">
            </mat-form-field>
            <mat-error *ngIf="!form.controls['observations'].valid && form.controls['observations'].touched">
                Câmp obligatoriu
            </mat-error>
        </div>

        <div class="spinner"><mat-spinner *ngIf="isLoading"></mat-spinner></div>
        <div class="platform-content-action-btns">
            <button type="button" class="buttons" mat-flat-button (click)="closeDialog()">Close</button>
            <button class="buttons" mat-flat-button color="primary" type="submit">Save</button>
        </div>
    </form>
</div>
